"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VestingDeployDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_dialog_form_1 = require("@dzambalaorg/mui-dialog-form");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const mui_inputs_picker_1 = require("@dzambalaorg/mui-inputs-picker");
const mui_inputs_mask_1 = require("@dzambalaorg/mui-inputs-mask");
const types_1 = require("@framework/types");
const validation_1 = require("./validation");
const VestingDeployDialog = (props) => {
    const { initialValues, ...rest } = props;
    const { owner, startTimestamp, cliffInMonth, monthlyRelease, contractTemplate } = initialValues;
    const fixedValues = {
        owner,
        startTimestamp,
        cliffInMonth,
        monthlyRelease,
        contractTemplate,
    };
    return ((0, jsx_runtime_1.jsxs)(mui_dialog_form_1.FormDialog, { initialValues: fixedValues, validationSchema: validation_1.validationSchema, message: "dialogs.deploy", testId: "VestingDeployForm", ...rest, children: [(0, jsx_runtime_1.jsx)(mui_inputs_core_1.SelectInput, { name: "contractTemplate", options: types_1.VestingContractTemplates }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "owner", required: true }), (0, jsx_runtime_1.jsx)(mui_inputs_picker_1.DateInput, { name: "startTimestamp" }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.NumberInput, { name: "cliffInMonth", required: true }), (0, jsx_runtime_1.jsx)(mui_inputs_mask_1.CurrencyInput, { name: "monthlyRelease", symbol: "%", required: true })] }));
};
exports.VestingDeployDialog = VestingDeployDialog;
//# sourceMappingURL=index.js.map